import React from 'react';

/**
 * Componente que inyecta CSS crítico inline en el head
 * Esto acelera el LCP (Largest Contentful Paint)
 */
export default function CriticalCSS() {
  React.useEffect(() => {
    // Solo inyectar una vez
    if (document.getElementById('critical-css')) return;

    const criticalCSS = `
      body {
        margin: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
          'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
          sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      
      * {
        box-sizing: border-box;
      }
      
      html, body, #root {
        width: 100%;
        height: 100%;
      }
      
      .spinner-border {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: .25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
      }
      
      @-webkit-keyframes spinner-border {
        to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
      }
      
      @keyframes spinner-border {
        to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
      }
      
      .visually-hidden {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border-width: 0 !important;
      }
    `;

    const style = document.createElement('style');
    style.id = 'critical-css';
    style.innerHTML = criticalCSS;
    
    // Inyectar en el head lo antes posible
    const head = document.head;
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  }, []);

  return null;
}
